module.exports = __webpack_public_path__ + "img/lp3-energy-transition.09457354.jpg";